export default store => store.auth.mode;
